import moment from "moment";
import { COUNTRY } from "./CountryConstant";

export const MAIN_HOLDER_ID = "root";
export const MAX_SECTION_WIDTH = 1200;
export const CHART_HEIGHT = 220;
export const CHART_WIDTH = 418;
export const APP_NAME = "PEOPLE";
export const URL_V1 = "v1/"
export const CUSTOM_DOMAIN_WEBSITE = "CRM3_CUSTOM_DOMAIN";
export const CUSTOM_DOMAIN_TIME = "5 minutes";
export const REGEX = {
  WEBSITE_DOMAIN: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/,
};
export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const CPFMonth = [
  {
      id: 1,
      name: 'Jan'
  },
  {
      id: 2,
      name: 'Feb'
  },
  {
      id: 3,
      name: 'Mar'
  },
  {
      id: 4,
      name: 'Apr'
  },
  {
      id: 5,
      name: 'May'
  },
  {
      id: 6,
      name: 'Jun'
  },
  {
      id: 7,
      name: 'Jul'
  },
  {
      id: 8,
      name: 'Aug'
  },
  {
      id: 9,
      name: 'Sep'
  },
  {
      id: 10,
      name: 'Oct'
  },
  {
      id: 11,
      name: 'Nov'
  },
  {
      id: 12,
      name: 'Dec'
  }
];
export const DAY_INTERVAlS = [
  "Current",
  "A1-30 days",
  "31-60 days",
  "61-90 days",
  "Over 90 days",
];

export const CHAR_CODES = {
  ENTER: 13
}
export const CONSTANTS = {
  DEFAULT_JOB_PIPELINE: "Default Job Pipeline",
  DEFAULT_PIPELINE: "Default Pipeline",
  SEGMENT: "Segment",
  PIPELINE: "Pipeline",
  STAGE: "Stage",
  STATUS: "Status",
  EMPTY_STRING: "",
  COLUMN_OPERATOR: " : ",
  REGULAR_DAYS: "Regular Days",
  PAYMENT: "Payment",
  EARNING: "EARNING",
  DEDUCTION: "DEDUCTION",
  BREAK_LINE: "\n",
  PER_PAYRUN: " per payrun",
  EMPTY_STRING_WITH_SPACE: " ",
  TERMINATED: "terminated",
  TERMINATION_INITIATED: "termination_initiated",
  FIRSTNAME: "firstName",
  LASTNAME: "lastName",
  BASIC_SALARY: "Basic/Salary",
  SEGMENT: "Segment",
  JOB_OPENING: "Job Opening",
  CTC: "CTC",
  REQUIRED: "required",
  STRING: "string",
  CANDIDATE: "Candidate",
  AMOUNT: "Amount",
  FREQUENCY: "Frequency",
  ACTION: "Action",
  FIXED_ALLOWANCE: "Fixed Allowance",
  CONVEYANCE_ALLOWANCE: "Conveyance Allowance",
  AMOUNT_PER_DAY: "amountPerDay",
  BASIC: "Basic",
  HRA: "HRA",
  EARNINGS: "Earning",
  DEDUCTION: "Deduction",
  CASHFREE_INFO_TEXT:
    "Please ensure that you fill all the provided information in <br> their respective pages before connecting to Cashfree",
  UPDATED: "UPDATED",
  ADDED: "ADDED",
  DELETED: "DELETED",
  BASIC_THRESHOLD: 100,
  HRA_THRESHOLD: 70,
  PERCENT_THRESHOLD: 100.0,
  INVALID: "Invalid",
  INVALID_IFSC: "IFSC Code Format (Ex: ABCD0123456), 5th character should 0",
  PLUS_SYMBOL_CODE: "%2B",
  FAILED_TO_ADD: "FAILED_TO_ADD",
  DIRECT_DEPOSIT: "Direct Deposit",
  CASH: "Cash",
  CHEQUE: "Cheque",
  CHECK: "Check",
  UPI: "Upi",
  EMPLOYEE: "Employee",
  COMPONENT: "Component",
  INVALID_ACCOUNT_NUMBER: "Account Number should have 6 to 40 characters",
  INVALID_US_ACCOUNT_NUMBER: "Account Number should have 4 to 17 characters",
  INVALID_US_ROUTING_NUMBER:
    "The first two of the 9 digits should be within the range 01-12 or 21-32.",
  INVALID_UPI: "Enter a valid UPI ID",
  BENEFIT: "BENEFIT",
  BENEFITS: "Benefit",
  PERCENT: "percent",
  PER_HOUR: " per hour",
  HOURLY: "hourly",
  CONTRACTOR: "CONTRACTOR",
  REGULAR_HOURS: "Regular Hours",
  HOUR: "hour",
  WEEK: "week",
  HOURS: "Hours",
  DRAFT: "draft",
  SUBMIT: "submit",
  REPORT_NO_ROUTE: "noRoute",
  EXPENSES: "Expenses",
  CURRENT_LIABILITY: "Current Liabilities",
  EXPENSE: "expense",
  LIABILITY: "liability",
  ACTIVE: "active",
  INACTIVE: "inactive",
  OTHER_EXPENSES: "Other Expenses",
  ADMIN: "ADMIN",
  MANAGER: "MANAGER",
  USER: "USER",
  ATTENDANCE: "Attendance",
  INVALID_UOB_ACCOUNT_NUMBER: "Account Number should have 9 characters",
  CODE: 'code',
  STATE: 'state',
  VALIDATE_AND_SUBMIT : "Validate and Submit",
  VALIDATE: "Validate",
  EMPLOYEE_ID: "Employee Id",
  HIRINGADMIN: "HIRINGADMIN",
  OWNER: "OWNER"
};
export const USRoutingNumberRegex = '^((0[0-9])|(1[0-2])|(2[1-9])|(3[0-2])|(6[1-9])|(7[0-2])|80)([0-9]{7})$';
export const SGRoutingNumberRegex = "^([0-9]{3})$";
export const DEFAULT_TRIAL_PLAN_DAYS = 15;
export const INPUT_TYPE = {
  TEXT: "text",
  // PASSWORD: "password",
  NUMBER: "number",
  EMAIL: "email",
  DATE: "date",
  URL: "text",
  SELECT: "select",
  MULTI_SELECT: "multi-select",
  CHECKBOX: "checkbox",
  BUTTON: "button",
  MORE: "more",
  DROPDOWN: "dropdown",
  AUTOCOMPLETE: "autocomplete",
  TOGGLE: "toggle",
  RADIO_BUTTON:'radioGroup',
  LONG_TEXT: "long text"
};

export const INPUT_FIELD_MAP = {
  ["text"] : INPUT_TYPE.TEXT,
  ["number"] : INPUT_TYPE.NUMBER,
  ["dropdown"] : INPUT_TYPE.DROPDOWN,
  ["multiselect"] : INPUT_TYPE.MULTI_SELECT,
  ["checkbox"]: INPUT_TYPE.CHECKBOX,
  ["select"] : INPUT_TYPE.SELECT,
  ["date"] : INPUT_TYPE.DATE
}

export const DATE_FORMAT = {
    IND: 'DD-MM-YYYY',
    IN_SHORT: 'DD-MM',
    YYYYMMDD: 'YYYY-MM-DD',
    US: 'MM-DD-YYYY',
    SLASH:{
      MMDDYYYY: 'MM/DD/YYYY',
      DDMMYYYY: 'DD/MM/YYYY'
    },
    YYYYMMDD_HHMM: 'YYYY-MM-DD HH:mm',
    YYYYMMDD_HHMMSS : 'YYYY-MM-DDTHH:mm:ss.SSSZ'
}
export const payDayMonthly = [
  {
    id: 'lastWorkingDayMonth',
    name: 'Last working day of the month'
  },
  { id: '1', name: '1' }
  , { id: '2', name: '2' }, { id: '3', name: '3' }, { id: '4', name: '4' }, { id: '5', name: '5' },
  { id: '6', name: '6' }, { id: '7', name: '7' }, { id: '8', name: '8' }, { id: '9', name: '9' }, { id: '10', name: '10' },
  { id: '11', name: '11' }, { id: '12', name: '12' }, { id: '13', name: '13' }, { id: '14', name: '14' }, { id: '15', name: '15' },
  { id: '16', name: '16' }, { id: '17', name: '17' }, { id: '18', name: '18' }, { id: '19', name: '19' }, { id: '20', name: '20' },
  { id: '21', name: '21' }, { id: '22', name: '22' }, { id: '23', name: '23' }, { id: '24', name: '24' }, { id: '25', name: '25' },
  { id: '26', name: '26' }, { id: '27', name: '27' }, { id: '28', name: '28' }
];

export const EXCLUDE_STEPPER_HEADER = ["PAYROLL", "EMPLOYEE_DEATILS"];

export const EMPLOYEE_FILTER = [
  {
    id: "all",
    name: "All",
    searchField: "",
  },
  {
    id: "active",
    name: "Active",
    searchField: "status",
  },
  {
    id: "termination_initiated",
    name: "Termination Initiated",
    searchField: "terminationStage",
  },
  {
    id: "terminated",
    name: "Terminated",
    searchField: "terminationStage",
  },
  {
    id: "draft",
    name: "Draft",
    searchField: "status",
  },
];

export const IMP_FIELDS = {
  EMAIL_ID: "EMAIL_ID",
  DATE_OF_JOINING: "DATE_OF_JOINING",
  DATE_OF_BIRTH: "DATE_OF_BIRTH",
  COMPLIANCE: "COMPLIANCE",
  PAYMENT_METHOD: "PAYMENT_METHOD"
};
export const TENENT_COUNTRY = "IN";
export const TENENT_CURRENCY = "INR";

export const PAN_NUMBER_MASK = `SSSSS0000S`;
export const TAN_NUMBER_MASK = 'SSSS00000S';
export const TDS_CIRCLE_MASK = 'SSSS000 | SSSS0000 | SSSSS000 | SSSSS0000';
export const EPF_NUMBER_MASK = 'SSSSS0000000000';
export const ESI_NUMBER_MASK = '00000000000000000';

export const COUNTRY_CODE = {
  INDIA: "IN",
  US:"US",
  MY:"MY",
  SINGAPORE: "SG",
  SG:"SG"
};

export const ERRORS_COMPONENTS = {
  VARIABLE: `The total amount exceeds the CTC, please recheck <br> the component values to and input accurate values`,
};
// EPF wage ceiling raised to 25,000 w.e.f. 17-Sep-2026 (ZEN-18887); older settings may still hold the legacy label
export const EPF_RESTRICT_TO_CEILING = 'Restrict to 25000';
export const EPF_RESTRICT_TO_CEILING_LEGACY = 'Restrict to 15000';
export const EPF_EMPLOYER_CONTRIBUTION = [ '12% of PF Wage', EPF_RESTRICT_TO_CEILING];

export const COLUMN_CODES = {
  EFFECTIVE_DATE: "effectiveDate",
  CTC: "ctc",
  PERIOD: "period",
  AMOUNT: "amount",
  DISBURSEMENT_DATE: "disbursementDate",
  REPAYMENTSTART_DATE: "repaymentStartDate",
  INSTALLMENT_AMOUNT: "installmentAmount",
  INSTALLMENTS: "installents",
  DATE_OF_BIRTH: "dateOfBirth",
  PF_ACCOUNT_NUMBER: "pfAccountNumber",
  PASSPORT_NUMBER: "passportNumber",
  ESI_NUMBER: "esiNumber",
  ESI_APPLICABLE: "esiApplicable",
  PASSPORT_COUNTRY: "passportCountry",
  IFSC_CODE: "ifsc",
  ACCOUNT_NUMBER: "accountNumber",
  CONTACT: "contact",
  DEFAULT_COMPENSATION: "defaultCompensation",
  UPI_ID: "upiId",
  ROUTING_NUMBER: "routingNumber",
  PAYMENT_METHOD: "paymentMethod",
  EFFECTIVE_PERIOD: "effectivePeriod",
  FEDERAL_FILING_STATUS: "federalFilingStatus",
  SELECTED_STATE_INDICATOR: "selectStateIndicator",
  TAXES_APPLICABLE: "taxesApplicable",
  STATUTORY_INDICATOR: "statutoryIndicator",
  WHT_434: "WHT434",
  C101_C_147: "WHT436",
  WHT_436: "FORMC147",
  FORM_940: "FORM940",
  GENDER: "gender",
  MARITAL_STATUS: "maritalStatus",
  DEPENDENT_CLAIMS: "dependentClaims",
  OTHER_INCOME: "otherIncome",
  DEDUCTIONS: "deductions",
  EXTRA_WITHHOLDINGS: "extraWithholdings",
  MULTIPLE_JOBS: "twocmarkedinw4",
  DATE_OF_CONFIRMATION: "dateOfConfirmation",
  DATE_OF_JOINING: "dateOfJoining",
  INVITE_USER: "inviteUserToFillInfo",
  ALIAS_NAME: "aliasName",
  EMAIL_ID: "emailId",
  FOREIGN_INCOME_EARNED: "foreignEarnedIncome",
  TAX_EXEMPT: "taxExemptions",
  RESIDENT_COUNTRY: "residentCountry",
  DATE_OF_JE: "dateOfJE",
  DATE_OF_REVERSAL_JE: "dateOfReversalOfJE",
  PASSPORT_ISSUANCE_COUNTRY: "i9ForeignPassportIssuanceCountry",
  LOCATION_VALUE: "locationValue",
  IS_PT_APPLICABLE: "isPTApplicable",
  EMPLOYEEID: "employeeId",
  BANK: "bank",
  ACCOUNT_TYPE: "accountType",
  NATIONALITY: "nationality",
  COUNTRY_OF_ORIGIN: "countryOfOrigin",
  ASSIGN_CPF_ACCOUNT: "assignCPFAccount",
  STRATEGIC_PROJECT: "strategicProject",
  ESI_NUMBER : "esiNumber",
  SSN: "socialSecurityNumber",
  EIS_CONTIRBUTION: "eisContribution",
  DEFAULT_HRS: "hourlyWageDefaultHrs",
  EFFECTIVE_DEFAULT_HRS: "effectiveDefaultHrs",
  EMPLOYMENT_TYPE: "employeeType",
};

export const COMPONENT_TYPE = {
  EARNING: "EARNING",
  DEDUCTION: "DEDUCTION",
};
export const PROFILE_STAGES_CONSTANT = {
  COMPANY_DETAILS: 'companyDetails',
  PAY_SCHEDULE: 'paySchedule',
  EMPLOYEE_DETAILS: 'employeeDetails',
  PAYMENT_DETAILS: 'paymentDetails',
  CPF_DETAILS: 'cpfDetails',
  TAX_DETAILS: 'taxDetails',
  COMPONENT: 'payrollComponents',
  BANK_DETAILS: 'bankDetails',
  FILLING_AUTH: 'filingAuthorization'
};
export const IN_COMPONENT_MAX_LIMIT = {
  basic: 70,
  other: 70
}
export const IT_DECLARE_STATUS = [
  {
    id: "SUBMITTED",
    name: "Submitted"
  },
  {
    id: "NOT_SUBMITTED",
    name: "Not Submitted"
  },
  {
    id: "APPROVAL_PENDING",
    name: "Approval Pending"
  },
  {
    id: "APPROVED",
    name: "Approved"
  }
]

export const PAYMENT_MAP = {
  ["directDeposit"]: CONSTANTS.DIRECT_DEPOSIT,
  ["cash"]: CONSTANTS.CASH,
  ["cheque"]: CONSTANTS.CHEQUE,
  ["check"]: CONSTANTS.CHECK,
  ["upi"]: CONSTANTS.UPI
};

export const CASHFREE_PAYMENT_STATUS = {
  PAYMENT_PENDING: "Payment Pending",
  NOT_PAID: "Not Paid",
  PAID: "Paid",
  PAYMENT_FAILED: "Payment Failed",
  PARTIALLY_PAID: "Partially Paid"
};

export const CASHFREE_STATUS_MAP = {
  ["Invalid account number or ifsc provided"] : "FAILURE",
  ["ifsc should be of 11 characters and 5th character should be 0."] : "FAILURE"
}
export const payPeriod = [
  {
      id: 'monthly',
      name: 'Monthly',
      color: "data-grid-badge-color-2"
  },
  {
      id: 'weekly',
      name: 'Weekly',
      color: "data-grid-badge-color-2"
  },
  {
      id: 'twicePerMonth',
      name: 'Twice Per Month',
      color: "data-grid-badge-color-2"
  },
  {
      id: 'biWeekly',
      name: 'Bi-Weekly',
      color: "data-grid-badge-color-2"
  }
];
export const workWeek = [
  {
    id: 'lastWorkingDayWeek',
    name: 'Last working day of the week'
  },
  {
    id: '0',
    shortName: 'SUN',
    name: 'Sunday',
    sequence: 6
  },
  {
      id: '1',
      shortName: 'MON',
      name: 'Monday',
      sequence: 0
  },
  {
      id: '2',
      shortName: 'TUE',
      name: 'Tuesday',
      sequence: 1
  },
  {
      id: '3',
      shortName: 'WED',
      name: 'Wednesday',
      sequence: 2
  },
  {
      id: '4',
      shortName: 'THU',
      name: 'Thursday',
      sequence: 3
  },
  {
      id: '5',
      shortName: 'FRI',
      name: 'Friday',
      sequence: 4
  },
  {
      id: '6',
      shortName: 'SAT',
      name: 'Saturday',
      sequence: 5
  },
];
export const biWeeklyPayDays = [

  {
      id: '0',
      name: '1st Sunday',
      sequence: 6,

    },
    {
        id: '1',
        name: '1st Monday',
        sequence: 0
    },
    {
        id: '2',
        name: '1st Tuesday',
        sequence: 1
    },
    {
        id: '3',
        name: '1st Wednesday',
        sequence: 2
    },
    {
        id: '4',
        name: '1st Thursday',
        sequence: 3
    },
    {
        id: '5',
        name: '1st Friday',
        sequence: 4
    },
    {
        id: '6',
        name: '1st Saturday',
        sequence: 5
    },
    {
      id: '7',
      name: '2nd Sunday',
      sequence: 7
    },
    {
        id: '8',
        name: '2nd Monday',
        sequence: 8
    },
    {
        id: '9',
        name: '2nd Tuesday',
        sequence: 9
    },
    {
        id: '10',
        name: '2nd Wednesday',
        sequence: 10
    },
    {
        id: '11',
        name: '2nd Thursday',
        sequence: 11
    },
    {
        id: '12',
        name: '2nd Friday',
        sequence: 12
    },
    {
        id: '13',
        name: '2nd Saturday',
        sequence: 13
    },
];
export const payDayTwicePerMonthDays = [
  {
      id: '15AndLastOfMonth',
      name: '15th and last day of the month'
  },
];

export const CASHFREE_MESSAGE_MAP = {
  ["transfer mode not enabled for the account"] : {status : true, message:"Enabled transfer mode for accounts"},
  ["Beneficiary does not exist"] : {status : true, message:"Employee(s) are added as beneficiaries"},
  ["Not enough available balance in the account"] : {status : true, message:"You have sufficient balance in your account"}
}

export const SSN_VALIDATIONS_MAP = [
  "It should be of the format 000-00-0000 where 0-Number.",
  "The first part should have 3 digits and should not be 000, 666, or between 900 and 999.",
  "The second part should have 2 digits and it should be from 01 to 99.",
  "The third part should have 4 digits and it should be from 0001 to 9999"
]

export const MESSAGES_TOOLTIP = {
  VALID_SSN: `<div><div class='d-flex fs-m' style='justify-content:flex-start;'>The valid SSN must satisfy the following conditions: </div>${SSN_VALIDATIONS_MAP.map(
    (f, i) =>
      `<div class='d-flex fs-s' style='justify-content:flex-start; padding-top:3px'>${
        i + 1
      }. ${f}</div>`
  ).join("")}</div>`,
};


export const COMPANY_DATE_FORMATS = [
    {
        value: 'dd-MM-yyyy',
        label: 'DD-MM-YYYY',
        short: 'DD-MM'
    },
    {
        value: 'MM-dd-yyyy',
        label: 'MM-DD-YYYY',
        short: 'MM-DD'
    },
    {
        value: 'yyyy-MM-dd',
        label: 'YYYY-MM-DD',
        short: 'MM-DD'
    }
];

export const DECIMAL_PLACES = [
    {
        value: 1,
        label: '1'
    },
    {
        value: 2,
        label: '2'
    },
    {
        value: 3,
        label: '3'
    },
    {
        value: 4,
        label: '4'
    }
];

export const FORMAT = {
    DDMMYYYY: "DD-MM-YYYY",
    DDMMYYYY_2: "DD/MM/YYYY",
    DDMM: 'DD-MM',
    DDMM_2: 'DD/MM',
    MMDDYYYY: "MM-DD-YYYY",
    MMDDYYYY_2: "MM/DD/YYYY",
    MMDD: "MM-DD",
    MMDD_2: "MM/DD",
    YYYYMMDD: 'YYYY-MM-DD',
    YYYYMMDD_2: 'YYYY/MM/DD',
    YYYYMMDD_HHMM: 'YYYY-MM-DD HH:mm',
    HHMM: 'HH:mm',
    HHMM_A: 'HH:mm A',
    HHMM_A_2: 'hh:mm A'
}

export const ATTENDANCE_TYPE = {
  CLOCK_IN: "CLOCK_IN",
  CLOCK_OUT: "CLOCK_OUT"
}

export const FORM_ACTIONS = {
  EDIT: "EDIT",
  ADD: "ADD"
}


export const VIEWPORT_SIZES = {
    EXTRA_SMALL: "xs",
    SMALL: "sm",
    LARGE: "lg",
};

export const BREAKPOINTS = {
    SMALL: 560,
    LARGE: 800,
};

export const DEFAULT_INTEGRATION_ACCOUNTS = {
  EXPENSE_DEFAULT_ACCOUNT: "ACC70003",
  LIABILITY_DEFAULT_ACCOUNT: "ACC40004",
}

export const COMPLIANCE_TOOLTIP_FIELDS_MESSAGES = {
  ["federalFilingStatus"]:
    "Federal filing status indicates to the system whether the employee being processed is eligible for the earned income credit.",
  ["selectStateIndicator"]:
    "Please select for which state the Unemployment Insurance needs to be withheld.",
  ["taxesApplicable"]:
    "We recommend you keep the default option of all, but if your employee only needs certain taxes withheld then you can choose from the options below.",
  ["statutoryIndicator"]:
    "We recommend Common Law as all taxes will be calculated for that employee, but you can choose specific taxes to be withheld in the dropdown options",
  ["dependentClaims"]:
    "Enter the results for line 3 from the <b>IRS calculator</b> or <b>form W-4.</b>",
  ["otherIncome"]:
    "Enter the results for line 4a from the <b>IRS calculator</b> or <b>form W-4.</b>",
  ["deductions"]:
    "Enter the results for line 4b from the <b>IRS calculator</b> or <b>form W-4.</b>",
  ["extraWithholdings"]: `Enter the results for line 4c from the <b>IRS calculator</b> or <b>form W-4.</b>`,
  ["twocmarkedinw4"]: `Includes spouse (if applicable). Answering 2c results in higher withholding, but to preserve privacy, this can be left unchecked. To learn more, read <b>the IRS’s instructions.</b>`,
  [COLUMN_CODES.RESIDENT_COUNTRY]: "Please select where this employee is a citizen or a resident.",
  [COLUMN_CODES.ESI_NUMBER]: `ESI Number should be of 10 to 17 digits`,
  [COLUMN_CODES.SSN]: MESSAGES_TOOLTIP.VALID_SSN,
  [COLUMN_CODES.EIS_CONTIRBUTION]:  `Please note that once enabled, SOCSO/EIS contribution cannot be disabled.`
};

export const INITIAL_PAYROLL_FILTERS = [
  { id: 0, name: "All", key: "" },
  { id: 1, name: "Direct Deposit", key: "directDeposit" },
  { id: 2, name: "Cash", key: "cash" },
  { id: 3, name: "Cheque", key: "cheque" },
];

export const PAYMENT_MAP_US = {
  ["directDeposit"]: CONSTANTS.DIRECT_DEPOSIT,
  ["cash"]: CONSTANTS.CASH,
  ["cheque"]: CONSTANTS.CHECK,
  ["check"]: CONSTANTS.CHECK,
};

export const MOBILE_APP_ACTIONS = {
    HOME: 'HOME',
};
export const MESSAGES = {
  W2_TOOLTIP: "Includes Copy A, Copy B, Copy C, Copy D and Copy 2",
  MISC_TOOLTIP: "Includes Copy A, Copy B, Copy C, Copy 1 and Copy 2",
  START_DATE_ERR: "Start date should be less than End date",
  END_DATE_ERR: "End date should be greater than Start date",

};
export const WEEKDAYS_MAP = new Map([
  ['sunday',0],
  ['monday',1],
  ['tuesday',2],
  ['wednesday',3],
  ['thursday',4],
  ['friday',5],
  ['saturday',6]
]);

export const INPUT_FIELD_MAP_COMPLIANCE = {
  ["text"]: INPUT_TYPE.TEXT,
  ["number"]: INPUT_TYPE.NUMBER,
  ["dropdown"]: INPUT_TYPE.DROPDOWN,
  ["multiselect"]: INPUT_TYPE.MULTI_SELECT,
  ["checkbox"]: INPUT_TYPE.CHECKBOX,
  ["select"]: INPUT_TYPE.DROPDOWN,
  ["date"]: INPUT_TYPE.DATE,
  ["autocomplete"]: INPUT_TYPE.DROPDOWN,
  ["toggleButton"]: INPUT_TYPE.CHECKBOX,
  ["autocomplete"]: INPUT_TYPE.DROPDOWN,
};

export const YEAR = {
  TWO_THOUSAND_TWENTY : 2020,
  TWO_THOUSAND_NINETEEN : 2019
}

export const LANGUAGES = {
    ENGLISH_US: 'English (US)',
    ENGLISH_UK: 'English (UK)',
    ENGLISH_IN: 'English (IN)',
    // BAHASA_INDONESIA: 'Bahasa Indonesia',
    // FRENCH: 'French',
    // GERMAN: 'German',
    // SPANISH: 'Spanish',
    // HINDI: 'Hindi',
    // TAMIL: 'Tamil',
    // PUNJABI: 'Pubnjabi',
    // GUJARATI: 'Gujarati',
    // MARATHI: 'Marathi',
    // BENGALI: 'Bengali',
    // KANNADA: 'Kannada',
    // MALAYALAM: 'Malayalam',
    // TELUGU: 'Telugu'
};

export const LANGUAGES_CODE = {
    ENGLISH_US: 'en',
    ENGLISH_UK: 'en_GB',
    ENGLISH_IN: 'en_IN',
    // BAHASA_INDONESIA: 'id',
    // FRENCH: 'fr',
    // GERMAN: 'ge',
    // SPANISH: 'es',
    // HINDI: 'hi',
    // TAMIL: 'ta',
    // PUNJABI: 'pb',
    // GUJARATI: 'gj',
    // MARATHI: 'mh',
    // BENGALI: 'bg',
    // KANNADA: 'ka',
    // MALAYALAM: 'ma',
    // TELUGU: 'te'
};

export const TOOLTIP_TEXT = {
  EMPTY_STRING: "",
  EMAIL_ID:
    "Please be extra careful typing the address. We use it to grant access to the employee’s sensitive information.",
  INVITE_USER:
    "You’ll have to enter this employee’s personal, tax and bank account details yourself. We recommend letting them do it.",
};

export const COMPLIANCE_UPDATED_FIELDS = {
  [COLUMN_CODES.TAXES_APPLICABLE]: "Choose what taxes you want to pay",
  [COLUMN_CODES.FOREIGN_INCOME_EARNED]:
    "Is there any income earned outside of the USA?",
  [COLUMN_CODES.TAX_EXEMPT]: "Is this employee exempt of all taxes?",
};

export const DEFAULT_WORK_WEEK =  [
  {
    "day": "monday",
    "isWorkingDay": true,
    "startTime": "09:00 AM",
    "endTime": "06:00 PM",
    "duration": 9
  },
  {
    "day": "tuesday",
    "isWorkingDay": true,
    "startTime": "09:00 AM",
    "endTime": "06:00 PM",
    "duration": 9
  },
  {
    "day": "wednesday",
    "isWorkingDay": true,
    "startTime": "09:00 AM",
    "endTime": "06:00 PM",
    "duration": 9
  },
  {
    "day": "thursday",
    "isWorkingDay": true,
    "startTime": "09:00 AM",
    "endTime": "06:00 PM",
    "duration": 9
  },
  {
    "day": "friday",
    "isWorkingDay": true,
    "startTime": "09:00 AM",
    "endTime": "06:00 PM",
    "duration": 9
  },
  {
    "day": "saturday",
    "isWorkingDay": false,
    "startTime": "09:00 AM",
    "endTime": "06:00 PM",
    "duration": 9
  },
  {
    "day": "sunday",
    "isWorkingDay": false,
    "startTime": "09:00 AM",
    "endTime": "06:00 PM",
    "duration": 9
  }
]

export const DOCUMENT_STATUS_MAP = {
  ["INCOMPLETE"]: {
    status: "Incomplete",
    description: "Please complete the employee profile.",
  },
  ["DOWNLOAD"]: {
    status: "Ready for Download",
    description: "You can now download the form for signing the document.",
  },
  ["UPLOADED_DOCUMENT"]: {
    status: "Uploaded Document",
    description: "The document has been uploaded on",
  },
  ["SIGNED"]: {
    status: "Signed",
    description: "The document has been signed.",
  },
  ["READ_AND_ACCEPT"]: {
    status: "Read and Accepted",
    description: "The document has been read and accepted on",
  },
};

export const DEFAULT_US_FORMS = {
  ["W4"] : { isDefault: true },
  ["I9"] : { isDefault: true }
}

export const CHART_INTERVALS_CLAIMS_TREND = [
  {
    name: "This Week",
    interval: "weekly",
    searchKey: "WEEK",
  },
  {
    name: "This Month",
    interval: "monthly",
    searchKey: "MONTH",
  },
  {
    name: "This Quarter",
    interval: "quarterly",
    searchKey: "QUARTER",
  },
  {
    name: "This Year",
    interval: "yearly",
    searchKey: "YEAR",
  },
];

export const ENTITY = {
  EXPENSE: 'EXPENSE'
}

export const US_ADMIN_COMPAINCE_FIELDS = [
  "socialSecurityNumber",
  "federalFilingStatus",
  "maritalFilingStatus",
  "dependentClaims",
  "otherIncome",
  "deductions",
  "extraWithholdings",
  "i9Eligibility",
  "expiryDateOfWorkAuthorisation",
  "authorizationDocument",
  "i94AdmissionNumber",
  "alienRegNumber",
  "i9ForeignPassportNumber",
  "i9ForeignPassportIssuanceCountry",
];
export const FILE_TYPE = {
  PDF: 'pdf',
  JPG: 'jpg',
  JPEG: 'jpeg',
  PNG: 'png',
  SVG: 'svg',
  TXT: "txt",
  BMP: "bmp",
  DOC: "doc",
  DOCX: "docx",
  XLSX: "xlsx",
  XLS: "xls",
  CSV: "csv",
  PPTX: "pptx",
  PPT: "ppt"
}
export const CANDIDATE_ACCEPT_FILE_TYPE = ["image/*", "application/pdf", ".pdf",".txt",".doc",".xls" ," .ppt", ".docx", ".xlsx", ".pptx", ".jpg", ".jpeg ",".png",".gif",".csv"]

export const COMPLIANCE_SECTION = {
  ELIGIBILITY: "Eligibility (I-9)"
}

export const LOCATION = [
  'Business',
  'Department',
  'Division',
  'Location',
  'Property',
  'Store',
  'Territory'
]
export const ACCOUNT_TYPE = {
  BANK:"BANK",
  GIRO: "GIRO"
}

export const SMTP_HELP_LINKS = {
    GMAIL: "https://support.google.com/mail/answer/7126229?authuser=4&visit_id=637811109035473969-476327719&hl=en&rd=1#zippy=%2Cstep-change-smtp-other-settings-in-your-email-client",
    OUTLOOK: "https://support.microsoft.com/en-us/office/pop-imap-and-smtp-settings-for-outlook-com-d088b986-291d-42b8-9564-9c414e2aa040",
    YAHOO: "https://in.help.yahoo.com/kb/SLN4724.html?guccounter=1&guce_referrer=aHR0cHM6Ly93d3cuZ29vZ2xlLmNvbS8&guce_referrer_sig=AQAAAGLpxTbNqVoMI3lYE12umJrOlUI12VmRGHfEwv8BIMlc9l0coGOQwHCI85aPYS1u9vBeTkosjbb0XQOYrJRoP2xBfyyTNC0HDnFOQMBkronkzgO6mCqlt8kBYE_fNhPHbPd-oulXORYHemicr9sV7SbFbfh1qgf8MRugE9kZnMfC",
};
export const WORKWEEK_SEQUENCE = [
  {
    id: 0,
    shortName: 'SUN',
    name: 'Sunday',
    sequence: 6
  },
  {
    id: 1,
    shortName: 'MON',
    name: 'Monday',
    sequence: 0
  },
  {
    id: 2,
    shortName: 'TUE',
    name: 'Tuesday',
    sequence: 1
  },
  {
    id: 3,
    shortName: 'WED',
    name: 'Wednesday',
    sequence: 2
  },
  {
    id: 4,
    shortName: 'THU',
    name: 'Thursday',
    sequence: 3
  },
  {
    id: 5,
    shortName: 'FRI',
    name: 'Friday',
    sequence: 4
  },
  {
    id: 6,
    shortName: 'SAT',
    name: 'Saturday',
    sequence: 5
  },
];

export const IN_STATES_WITH_CONFIGURATION = [
  {
    value: "AN",
    label: "Andaman and Nicobar Islands",
    isPTApplicable: false,
  },
  {
    value: "AP",
    label: "Andhra Pradesh",
    isPTApplicable: true,
  },
  {
    value: "AR",
    label: "Arunachal Pradesh",
    isPTApplicable: false,
  },
  {
    value: "AS",
    label: "Assam",
    isPTApplicable: true,
  },
  {
    value: "BR",
    label: "Bihar",
    isPTApplicable: true,
  },
  {
    value: "CG",
    label: "Chandigarh",
    isPTApplicable: false,
  },
  {
    value: "CH",
    label: "Chhattisgarh",
    isPTApplicable: true,
  },
  {
    value: "DH",
    label: "Dadra and Nagar Haveli",
    isPTApplicable: false,
  },
  {
    value: "DD",
    label: "Daman and Diu",
    isPTApplicable: false,
  },
  {
    value: "DL",
    label: "Delhi",
    isPTApplicable: false,
  },
  {
    value: "GA",
    label: "Goa",
    isPTApplicable: false,
  },
  {
    value: "GJ",
    label: "Gujarat",
    isPTApplicable: true,
  },
  {
    value: "HR",
    label: "Haryana",
    isPTApplicable: false,
  },
  {
    value: "HP",
    label: "Himachal Pradesh",
    isPTApplicable: true,
  },
  {
    value: "JK",
    label: "Jammu and Kashmir",
    isPTApplicable: true,
  },
  {
    value: "JH",
    label: "Jharkhand",
    isPTApplicable: true,
  },
  {
    value: "KA",
    label: "Karnataka",
    isPTApplicable: true,
  },
  {
    value: "KL",
    label: "Kerala",
    isPTApplicable: true,
  },
  {
    value: "LA",
    label: "Ladakh",
    isPTApplicable: false,
  },
  {
    value: "LD",
    label: "Lakshadweep",
    isPTApplicable: false,
  },
  {
    value: "MP",
    label: "Madhya Pradesh",
    isPTApplicable: true,
  },
  {
    value: "MH",
    label: "Maharashtra",
    isPTApplicable: true,
  },
  {
    value: "MN",
    label: "Manipur",
    isPTApplicable: true,
  },
  {
    value: "ML",
    label: "Meghalaya",
    isPTApplicable: true,
  },
  {
    value: "MZ",
    label: "Mizoram",
    isPTApplicable: true,
  },
  {
    value: "NL",
    label: "Nagaland",
    isPTApplicable: true,
  },
  {
    value: "OR",
    label: "Odisha",
    isPTApplicable: true,
  },
  {
    value: "PY",
    label: "Puducherry",
    isPTApplicable: true,
  },
  {
    value: "PB",
    label: "Punjab",
    isPTApplicable: true,
  },
  {
    value: "RJ",
    label: "Rajasthan",
    isPTApplicable: true,
  },
  {
    value: "SK",
    label: "Sikkim",
    isPTApplicable: true,
  },
  {
    value: "TN",
    label: "Tamil Nadu",
    isPTApplicable: true,
  },
  {
    value: "TS",
    label: "Telangana",
    isPTApplicable: true,
  },
  {
    value: "TR",
    label: "Tripura",
    isPTApplicable: true,
  },
  {
    value: "UP",
    label: "Uttar Pradesh",
    isPTApplicable: false,
  },
  {
    value: "UK",
    label: "Uttarakhand",
    isPTApplicable: false,
  },
  {
    value: "WB",
    label: "West Bengal",
    isPTApplicable: true,
  },
];

export const PAYRUN_CALC_CRITERIAS = {
  NO_OF_DAYS_WORKED : "numberOfWorkingDaysInMonth",
  NO_OF_CALENDAR_DAYS : "numberOfCalendarDaysInMonth",
}
export const EMPLOYEE_ID_EXIST = "document code already exists";
export const DELETE_SEQ_FORMAT = "cannot delete sequence format as it's currently being used with some documents";

export const HIDE_CHAT_BUBBLE_CLASS = 'hide-chat-bubble';
export const ROUTING_REGEX = {
    ["US"]: { regex: USRoutingNumberRegex, error: CONSTANTS.INVALID_US_ROUTING_NUMBER },
    ["SG"]: { regex: SGRoutingNumberRegex, error: "Branch Code should be of 3 digits" },
  };
  

  export const ORGANIZATION_IDS = [
    { id: "UENBRN", name: "UEN - Business Registration Number" },
    { id: "UENLCR", name: "UEN - Local Company Registration" },
    { id: "ASGD", name: "ASGD" },
    { id: "ITR", name: "ITR" },
    { id: "UENO", name: "UENO" },
  ];
  
  export const EMPLOYEE_TYPES = [
      { id: 'privateSectorEmployee', name: 'Private sector employees' },
      { id: 'NPEStatutoryBodies', name: 'Non - Pensionable Employees (Statutory Bodies & Aided Schools)' },
      { id: 'NPEMinistries', name: 'Non - Pensionable Employees (Ministries)' },
      { id: 'PEStatutoryBodies', name: 'Pensionable Employees (Statutory Bodies)' },
      { id: 'PEMinistries', name: 'Pensionable Employees (Ministries)' }
  ];
  
  export const PAYMENT_CODES = [
      { id: 'PTE', name: 'PTE' },
      { id: 'AMS', name: 'AMS' }
  ];
  
  export const SECTOR_TYPES = [
      { id: 'services', name: 'Services' },
      { id: 'marine', name: 'Marine' },
      { id: 'process', name: 'Process' },
      { id: 'manufacturing', name: 'Manufacturing' },
      { id: 'construction', name: 'Construction' }
  ];
  
  export const OBLIGATIONS = [
    { id: 'employer', name: 'Employer' },
    { id: 'apprenticeship', name: 'Employee, Contract of Service orApprenticeship' },
    { id: 'wages', name: 'Wages' }
];
export const EMPLOYER_TYPES = [
    { id: 'public', name: 'Public Sector Employer' },
    { id: 'private', name: 'Private Sector Employer' },
    { id: 'others', name: 'ProfessionalBodies/Associations/Co-Operatives And Others (Non-SSM)Employee' }
];
export const EMPLOYER_TYPES_CATEGPORY_PUBLIC = [
    { id: 'Malaysian', name: 'Departments under the Malaysian Government' },
    { id: 'Local', name: 'Local Government' },
    { id: 'PublicSchool', name: 'Public Schools/Public Higher Education Institutions' },
    { id: 'PublicCommission', name: 'Public Commission' },
    { id: 'Statutory', name: 'Statutory Bodies' }
];
export const EMPLOYER_TYPES_CATEGPORY_PRIVATE = [
  { id: "SdnBhd", name: "SSM Registered Sdn Bhd" },
  { id: "BankNegara", name: "Bank Negara Approved Banks" },
  { id: "Businesses", name: "SSM Registered Businesses" },
  {
    id: "Government-linked",
    name: "Government-linked Company or Government-linked Investment Company",
  },
];
export const EMPLOYER_TYPES_CATEGPORY_PROFESSIONAL = [
    { id: 'Law', name: 'Law/Architect/Accounting Firms' },
    { id: ' Political', name: ' Political/Sports Bodies' },
    { id: 'MMC', name: 'Malaysian Medical Council (MMC) Registered Medical Practitioners' },
    { id: 'Voluntary', name: 'Voluntary Organisations/Non-profit/NGOs' },
    { id: 'Co-operative', name: 'Co-operative Commission RegisteredCo-operatives' }
];

export const EPF_PAYMENT_TYPES = [
  { id: "caruman", name: "A) e-Caruman" },
  { id: "fpx", name: "B) FPX" },
  { id: "debit", name: "C)​ ​Direct Debit Banks" },
];

export const ITEMS_TO_SKIP_CONTRIBUTION = ["shortFall"]
export const EXEMPT_FIELDS_FROM_INITIALS = [COLUMN_CODES.EMPLOYEEID]


export const ACCOUNT_NUMBER = {
  ["US"]: {
    isRegex: false,
    regexPattern: {},
    isMin: true,
    isMax: true,
    minValue: 4,
    maxValue: 17,
    minError: CONSTANTS.INVALID_US_ACCOUNT_NUMBER,
    maxError: CONSTANTS.INVALID_US_ACCOUNT_NUMBER,
  },
  ["SG"]: {
    isRegex: false,
    regexPattern: {},
    isMin: true,
    isMax: false,
    minValue: 0,
    minError: "",
  },
  ["IN"]: {
    isRegex: false,
    regexPattern: {},
    isMin: true,
    isMax: true,
    minValue: 6,
    maxValue: 40,
    minError: CONSTANTS.INVALID_ACCOUNT_NUMBER,
    maxError: CONSTANTS.INVALID_ACCOUNT_NUMBER,
  },
  ["MY"]: {
    rhbBank:{ isRegex: false,  regexPattern: {},isMin: true, isMax: true, minValue: 6,maxValue: 40, minError: CONSTANTS.INVALID_ACCOUNT_NUMBER, maxError: CONSTANTS.INVALID_ACCOUNT_NUMBER },
    publicBankBerhad:{ isRegex: false,  regexPattern: {},isMin: true, isMax: true, minValue: 6,maxValue: 40, minError: CONSTANTS.INVALID_ACCOUNT_NUMBER, maxError: CONSTANTS.INVALID_ACCOUNT_NUMBER },
    cimbBank:{ isRegex: false,  regexPattern: {},isMin: true, isMax: true, minValue: 6,maxValue: 40, minError: CONSTANTS.INVALID_ACCOUNT_NUMBER, maxError: CONSTANTS.INVALID_ACCOUNT_NUMBER },
    uobBank:{ isRegex: false,  regexPattern: {},isMin: true, isMax: true, minValue: 9,maxValue: 17, minError: "Account Number should have 9 to 17 characters", maxError: "Account Number should have 9 to 17 characters"},
    amBank:{ isRegex: false,  regexPattern: {},isMin: true, isMax: true, minValue: 6,maxValue: 40, minError: CONSTANTS.INVALID_ACCOUNT_NUMBER, maxError: CONSTANTS.INVALID_ACCOUNT_NUMBER }
  }
};

export const COMPLIANCE_FIELDS_WITH_OR_CONDITIONAL_FIELDS = ["alienRegNumber"];

export const INVALID_FIELD_TO_ID_MAP = {
    ["Unpaid Days"] : "daysOff",
    ["lopGreater"] : "daysOff",
    ["lopBeforeGreater"] : "daysOffBefore",
    ["lopAfterGreater"] : "daysOffAfter",
    ["hoursWorked"] : "hoursWorked",
    ["basicPayrun"] : "basicPayrun",
    ["rate"] : "rate",
    ["amount"] : "amount",
    ["rate1"] : "rate",
    ["amount1"] : "amount",
    ["paymentMethod"] : "paymentMethod",
    ["basicPay"]: "basicPayrun"
}

export const COUNTRY_RELIGION = {
    selfGroup: {
      CDAC: 'CDAC',
      SINDA: 'SINDA',
      ECF: 'ECF',
      MBMF: 'MBMF',
      NA: 'NA'
    }
};

// Employee Readonly Fields - ERF
export const ERF = {
    ADD_EMPLOYEE: {
        firstName: null,
        lastName: null,
        employeeId: null,
        emailId: null,
        designation: null,
        ctc: null,
        defaultCompensation: null,
        ifsc: null,
        routingNumber: null,
        accountNumber: null,
        upiId: null,
        installmentAmount: null
    }
}

// Admin Readonly Fields - ERF
export const ARF = {
    ADD_EMPLOYEE: {
        emailId: null
    }
}
export const FURNITUREFITTINGCONSTANTS = [
  {
      id: 'PARTIALLY_FURNISHED',
      name: 'Partially Furnished'
  },
  {
      id: 'FULLY_FURNISHED',
      name: 'Fully Furnished'
  }
];
export const REACT_TOOLTIP_CONST = {
  backgroundColor:"#fef6e1", borderColor:"#dcdcdc", textColor:"black", border:true
}
export const PLACEHOLDER_IDENTIFIER = `custom_email_placeholder`;

export const AUTO_CLOCK_TIME_DURATION = [
    {
        value: 0,
        label: 'As shift/workday ends',
    },
    {
        value: 1,
        label: 'After 1 hour',
    },
    {
        value: 2,
        label: 'After 2 hours',
    },
    {
        value: 3,
        label: 'After 3 hours',
    },
    {
        value: 4,
        label: 'After 4 hours',
    },
    {
        value: 5,
        label: 'After 5 hours',
    },
    {
        value: 6,
        label: 'After 6 hours',
    }
];
export const DESIGNER_TEMPLATE = {
  id: 0,
  templateName: 'Payslip Default Template',
  appName: APP_NAME,
  templateData: ''
};

export const DEFAULT_FIELD_VALUES = {
    ["MY"]: {
      uobBank:{ fieldId: "routingNumber", defaultValue: "000" },
      rhbBank:{ fieldId: "routingNumber", defaultValue: "" },
      publicBankBerhad:{ fieldId: "routingNumber", defaultValue: "" },
      cimbBank:{ fieldId: "routingNumber", defaultValue: "" },
      amBank:{ fieldId: "routingNumber", defaultValue: "" },
    }
  };
export const LOCALISATION_TEXT = {
  IN: {
    UID_NO: "PAN"
  },
  MY: {
    UID_NO: "Passport/IC"
  }
};

export const FULL_MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

export const WEEK_DAYS = [
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat"
];

export const YEARS = [
    "1990",
    "1991",
    "1992",
    "1993",
    "1994",
    "1995",
    "1996",
    "1997",
    "1998",
    "1999",
    "2000",
    "2001",
    "2002",
    "2003",
    "2004",
    "2005",
    "2006",
    "2007",
    "2008",
    "2009",
    "2010",
    "2011",
    "2012",
    "2013",
    "2014",
    "2015",
    "2016",
    "2017",
    "2018",
    "2019",
    "2020",
    "2021",
    "2022",
    "2023",
    "2024",
    "2025",
    "2026",
    "2027",
    "2028",
    "2029",
    "2030",
];
export const DASHBOARD_TEAM_ATTENDANCE = [
  {
    "name": "Employee Name",
    "type": "text",
    "index": 0,
    "options": [
      
    ],
    "required": true,
    "width": 360,
    "editable": false,
    "hidden": false,
    "uiVisible": true,
    "systemField": true,
    "columnCode": "employeeName",
    "id": "pFVi",
    "key": "pFVi"
  },
  {
    "name": "Status",
    "type": "select",
    "index": 9,
    "options": [
      {
        "id": "absent",
        "name": "Absent",
        "color": "data-grid-badge-color-4"
      },
      {
        "id": "present",
        "name": "Present",
        "color": "data-grid-badge-color-6"
      },
      {
        "id": "holiday",
        "name": "Holiday",
        "color": "data-grid-badge-color-8"
      }
    ],
    "required": true,
    "width": window.innerWidth <=1368 ? 90:150,
    "editable": false,
    "hidden": false,
    "uiVisible": true,
    "systemField": true,
    "columnCode": "status",
    "id": "kCrc",
    "allowAddOption": true,
    "key": "kCrc"
  },
  {
    "name": "First In",
    "type": "text",
    "index": 5,
    "options": [
      
    ],
    "required": true,
    "width": window.innerWidth <=1368 ? 100:150,
    "editable": false,
    "hidden": false,
    "uiVisible": true,
    "systemField": true,
    "columnCode": "clockIn",
    "id": "qG5Q",
    "key": "qG5Q"
  },
  {
    "name": "Last Out",
    "type": "text",
    "index": 6,
    "options": [
      
    ],
    "required": false,
    "width": window.innerWidth <=1368 ? 100:(window.innerWidth <= 1680 ? 150:300),
    "editable": false,
    "hidden": false,
    "uiVisible": true,
    "systemField": true,
    "columnCode": "clockOut",
    "id": "fJfH",
    "key": "fJfH"
  }
]
export const STATUS_OPTION = [{id:'DRAFT',name:'Draft', color:"entry-status draft"},{id:'SUBMITTED',name:'Submitted',color:"entry-status submitted"},{id:'APPROVED',name:'Approved',color:"entry-status approved"}, {id:'REJECTED',name:'Rejected',color:"entry-status rejected"}]
export const TIMESHEET_REORT_MAIN_GRID_COLUMN = [
  {
    "name": "Date",
    "type": "text",
    "index": 6,
    "options": [],
    "required": false,
    "width": 130,
    "editable": false,
    "hidden": false,
    "uiVisible": true,
    "systemField": true,
    "columnCode": "dateView",
    "allowFilter": false,
    "id": "dateView",
    "key": "dateView"
  }]
  
  export const TIMESHEET_REORT_SUB_GRID_COLUMN = [
   
    {
      "name": "Employees",
      "type": "text",
      "index": 6,
      "options": [],
      "required": false,
      "width": 230,
      "editable": false,
      "hidden": false,
      "uiVisible": true,
      "systemField": true,
      "columnCode": "employeeId",
      "id": "employeeId",
      "key": "employeeId"
    }]

export const ROW_DATA = [
  {
    date:moment().format("YYYY-MM-DD"),
    groupByEmployee: [
      {
        employeeId:"Rohan Shelar",
        reportData: [
          {
            "id": "63c0ef61e30d75b21d8de89e",
            "customer": "10828316",
            "projectId": "63a3f1954163972748f2f761",
            "projectName": "rohan",
            "projectCode": "123",
            "jobId": "63a457ce39d6e791eb51a84a",
            "jobName": "Billable task",
            "fromDate": "2023-01-13T05:42:36Z",
            "toDate": "2023-01-13T05:42:36Z",
            "employeeId": "6372177095029bed9e1d7279",
            "employeeName": "email_temp@deskera.club kmkm",
            "status": "SUBMITTED",
            "isBillable": true,
            "seconds": 0,
            "ratePerHour": 10,
            "amount": 0,
            "customerName": "Rohan"
          },
          {
            "id": "63c0ef61e30d75b21d8de89e",
            "customer": "10828316",
            "projectId": "63a3f1954163972748f2f761",
            "projectName": "rohan",
            "projectCode": "123",
            "jobId": "63a457ce39d6e791eb51a84a",
            "jobName": "Billable task",
            "fromDate": "2023-01-13T05:42:36Z",
            "toDate": "2023-01-13T05:42:36Z",
            "employeeId": "6372177095029bed9e1d7279",
            "employeeName": "email_temp@deskera.club kmkm",
            "status": "REJECTED",
            "isBillable": true,
            "seconds": 0,
            "ratePerHour": 10,
            "amount": 0,
            "customerName": "Rohan"
          },
          {
            "id": "63c0ef61e30d75b21d8de89e",
            "customer": "10828316",
            "projectId": "63a3f1954163972748f2f761",
            "projectName": "rohan",
            "projectCode": "123",
            "jobId": "63a457ce39d6e791eb51a84a",
            "jobName": "Billable task",
            "fromDate": "2023-01-13T05:42:36Z",
            "toDate": "2023-01-13T05:42:36Z",
            "employeeId": "6372177095029bed9e1d7279",
            "employeeName": "email_temp@deskera.club kmkm",
            "status": "APPROVED",
            "isBillable": true,
            "seconds": 0,
            "ratePerHour": 10,
            "amount": 0,
            "customerName": "Rohan"
          }
        ]
      }
    ]
  },
  {
    date:moment().subtract(1,'d').format("YYYY-MM-DD"),
    groupByEmployee: [
      {
        employeeId:"Rohan Shelar",
        reportData: [
          {
            "id": "63c0ef61e30d75b21d8de89e",
            "customer": "10828316",
            "projectId": "63a3f1954163972748f2f761",
            "projectName": "rohan",
            "projectCode": "123",
            "jobId": "63a457ce39d6e791eb51a84a",
            "jobName": "Billable task",
            "fromDate": "2023-01-13T05:42:36Z",
            "toDate": "2023-01-13T05:42:36Z",
            "employeeId": "6372177095029bed9e1d7279",
            "employeeName": "email_temp@deskera.club kmkm",
            "status": "SUBMITTED",
            "isBillable": true,
            "seconds": 0,
            "ratePerHour": 10,
            "amount": 0,
            "customerName": "Rohan"
          }
        ]
      },
      {
        employeeId:"King Sing",
        reportData: [
          {
            "id": "63c0ef61e30d75b21d8de89e",
            "customer": "10828316",
            "projectId": "63a3f1954163972748f2f761",
            "projectName": "rohan",
            "projectCode": "123",
            "jobId": "63a457ce39d6e791eb51a84a",
            "jobName": "Billable task",
            "fromDate": "2023-01-13T05:42:36Z",
            "toDate": "2023-01-13T05:42:36Z",
            "employeeId": "6372177095029bed9e1d7279",
            "employeeName": "email_temp@deskera.club kmkm",
            "status": "SUBMITTED",
            "isBillable": true,
            "seconds": 0,
            "ratePerHour": 10,
            "amount": 0,
            "customerName": "Rohan"
          }
        ]
      }
    ]
  },
  {
    date:moment().subtract(2,'d').format("YYYY-MM-DD"),
    groupByEmployee: [
      {
        employeeId:"Rohan Shelar",
        reportData: [
          {
            "id": "63c0ef61e30d75b21d8de89e",
            "customer": "10828316",
            "projectId": "63a3f1954163972748f2f761",
            "projectName": "rohan",
            "projectCode": "123",
            "jobId": "63a457ce39d6e791eb51a84a",
            "jobName": "Billable task",
            "fromDate": "2023-01-13T05:42:36Z",
            "toDate": "2023-01-13T05:42:36Z",
            "employeeId": "6372177095029bed9e1d7279",
            "employeeName": "email_temp@deskera.club kmkm",
            "status": "SUBMITTED",
            "isBillable": true,
            "seconds": 0,
            "ratePerHour": 10,
            "amount": 0,
            "customerName": "Rohan"
          },
          {
            "id": "63c0ef61e30d75b21d8de89e",
            "customer": "10828316",
            "projectId": "63a3f1954163972748f2f761",
            "projectName": "rohan",
            "projectCode": "123",
            "jobId": "63a457ce39d6e791eb51a84a",
            "jobName": "Billable task",
            "fromDate": "2023-01-13T05:42:36Z",
            "toDate": "2023-01-13T05:42:36Z",
            "employeeId": "6372177095029bed9e1d7279",
            "employeeName": "email_temp@deskera.club kmkm",
            "status": "SUBMITTED",
            "isBillable": true,
            "seconds": 0,
            "ratePerHour": 10,
            "amount": 0,
            "customerName": "Rohan"
          }
        ]
      }
    ]
  },
  {
    date:moment().subtract(3,'d').format("YYYY-MM-DD"),
    groupByEmployee: [
      {
        employeeId:"Rohan Shelar",
        reportData: [
          
          {
            "id": "63c0ef61e30d75b21d8de89e",
            "customer": "10828316",
            "projectId": "63a3f1954163972748f2f761",
            "projectName": "rohan",
            "projectCode": "123",
            "jobId": "63a457ce39d6e791eb51a84a",
            "jobName": "Billable task",
            "fromDate": "2023-01-13T05:42:36Z",
            "toDate": "2023-01-13T05:42:36Z",
            "employeeId": "6372177095029bed9e1d7279",
            "employeeName": "email_temp@deskera.club kmkm",
            "status": "SUBMITTED",
            "isBillable": true,
            "seconds": 0,
            "ratePerHour": 10,
            "amount": 0,
            "customerName": "Rohan"
          }
        ]
      }
    ]
  }
]
export const FINANCIAL_MONTHS = [
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
];

export const LOG_MAP  = {
  ["field"] : "Field",
  ["beforeUpdate"] : "Before Update",
  ["afterUpdate"] : "After Update"
}
export const PERIOD_MAP = {
  ["30"] : "Monthly",
  ["365"] : "Yearly",
  ["hourly"] : "Hourly",
  ["weekly"] : "Weekly"
}
export const APPLICABLE_TO_ALL = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' }
];
export const IN_TAX_REGIME_OPTIONS = {
  OLD_TAX_REGIME : "OLD_REGIME",
  NEW_TAX_REGIME : "NEW_REGIME",
}

export const FILE_EXTENSION_GROUP = {
  ALL: null,
  IMAGE: [
    "image/jpg",
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/svg",
    "image/svg+xml"
  ],
  XLS: [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "text/csv"
  ],
  DOC: [
    "text/plain",
    "application/txt",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  ],
  PDF: ["application/pdf"],
  PPT: [
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation"
  ]
};

export const NONE_OPTION = { id: "", name: "None" };

export const VALID_FIELD_MAX_LENGTH = {
  EMAIL: 254
}
export const EMAIL_ERROR_CODE = {
  EXIST_1001: "EXIST_1001",
  EXIST_1002: "EXIST_1002"
}